import { c as _c } from "react/compiler-runtime";
import { FormSelect } from '@systemeio/ui';
import EditTriggerWrapper from 'modules/automation-rules/triggers/components/edit-triggers/components/edit-trigger-wrapper';
import { EditTriggerItemInterface } from 'modules/automation-rules/triggers/components/edit-triggers/types/edit-trigger-item-interface';
import { AutomationRuleTriggersDataEnum } from 'modules/automation-rules/triggers/enums/trigger-enum';
import { TriggerCourseBundleEditInterface } from 'modules/automation-rules/triggers/types/automation-rule-triggers-edit-interface';
import { getDataFromObj } from 'modules/automation-rules/utils/get-filter-data';
import React from 'react';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { OpenInNewIcon } from '@systemeio/ui/icons';
interface TriggerCourseBundleItemProps extends EditTriggerItemInterface<TriggerCourseBundleEditInterface> {}
const TriggerCourseBundleItem = t0 => {
  const $ = _c(16);
  const {
    trigger,
    triggers,
    errors,
    idx,
    onDelete,
    setRules,
    isStatic
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== idx || $[1] !== onDelete) {
    t1 = () => onDelete(idx);
    $[0] = idx;
    $[1] = onDelete;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== errors.automationTriggers || $[4] !== idx || $[5] !== isStatic || $[6] !== setRules || $[7] !== t || $[8] !== trigger.courseBundle || $[9] !== trigger.id || $[10] !== triggers) {
    t2 = t3 => {
      const {
        data,
        onOpen,
        renderTriggerLabel
      } = t3;
      return <><FormSelect disabled={isStatic} onOpen={() => onOpen(AutomationRuleTriggersDataEnum.enrolled_in_course_bundle)} label={renderTriggerLabel({
          label: t("dashboard.course_bundle.title_one"),
          additionalLabel: trigger.courseBundle.id ? <LinkWithoutPrefetch href={`/course-bundles/${trigger.courseBundle.id}`} rel="noreferrer" target="_blank" className="group self-center outline-hidden"><OpenInNewIcon className="main-transition-colors group-focus-visible:fill-brand-primary hover:fill-brand-primary" /></LinkWithoutPrefetch> : undefined
        })} placeholder={t("dashboard.automation_rule.choose_course_bundle")} value={trigger.courseBundle.id} staticData={getDataFromObj(trigger.courseBundle)} data={data.courseBundleData} onChange={data_0 => setRules(prev => ({
          ...prev,
          triggers: triggers.map((el, i) => {
            if (idx === i) {
              return {
                ...el,
                courseBundle: {
                  id: data_0
                }
              };
            } else {
              return el;
            }
          })
        }))} error={errors.automationTriggers[trigger.id]?.courseBundle?.join("")} /></>;
    };
    $[3] = errors.automationTriggers;
    $[4] = idx;
    $[5] = isStatic;
    $[6] = setRules;
    $[7] = t;
    $[8] = trigger.courseBundle;
    $[9] = trigger.id;
    $[10] = triggers;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== t1 || $[13] !== t2 || $[14] !== trigger) {
    t3 = <EditTriggerWrapper trigger={trigger} onDelete={t1}>{t2}</EditTriggerWrapper>;
    $[12] = t1;
    $[13] = t2;
    $[14] = trigger;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  return t3;
};
export default TriggerCourseBundleItem;